import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Container, Slide, Dialog, DialogTitle } from "@mui/material";
import loader from "../Assets/loader.gif";
import { useS3PresignedUrlQuery } from "../../app/services/userCore";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ResourceDialog({
  open,
  setOpen,
  subject,
  resourceType,
  resourceData,
}) {
  const [playbackError, setPlaybackError] = useState(false);

  const { data, isLoading, isSuccess, isError, error } = useS3PresignedUrlQuery(
    {
      subject: subject,
      s3Key: resourceData?.s3Key,
      extension: resourceType === "VIDEO" ? "mp4" : "pdf",
    }
  );

  useEffect(() => {
    if (isError) {
      console.error(error);
    }
  }, [isError, error]);

  return (
    <div>
      <BootstrapDialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        aria-labelledby="customized-dialog-title"
      >
        <Container
          maxWidth="lg"
          style={{
            height: "100vh",
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 500,
              fontSize: "200%",
              textAlign: "center",
              textDecoration: "underline",
              textTransform: "capitalize",
            }}
            id="customized-dialog-title"
          >
            {subject} - {resourceData.title}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[1000],
            }}
          >
            <CloseIcon />
          </IconButton>

          {isLoading && (
            <div
              style={{
                textAlign: "center",
                width: "50%",
                margin: "auto",
              }}
            >
              <img src={loader} width={"100%"} />
            </div>
          )}

          {isSuccess && (
            <>
              {playbackError && (
                <div
                  style={{
                    textAlign: "center",
                    marginBottom: "2%",
                    color: "red",
                    fontWeight: "bold",
                    fontSize: "large",
                  }}
                >
                  Could not load the video. Try refreshing.
                  <br />
                  If it still does not work, contact{" "}
                  <mark>o1codingclub.mail@gmail.com</mark>
                </div>
              )}
              {resourceType === "VIDEO" && (
                <video
                  width="100%"
                  height="85%"
                  controls
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                  onError={() => setPlaybackError(true)}
                  onLoad={() => setPlaybackError(false)}
                >
                  <source src={data?.data} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}

              {resourceType === "PDF" && (
                <div
                  style={{ width: "100%", height: "85%", overflow: "scroll" }}
                >
                  <iframe
                    style={{
                      pointerEvents: "none",
                      overflow: "none",
                    }}
                    src={data?.data + "#toolbar=0"}
                    title="PDF Viewer"
                    width={"100%"}
                    height={`${10 * 1}00%`}
                    type="application/pdf"
                    allow="fullscreen"
                  >
                    <p>Your browser does not support iframes.</p>
                  </iframe>
                </div>
              )}
            </>
          )}
        </Container>
      </BootstrapDialog>
    </div>
  );
}
